import type { CSSProperties, RefObject } from 'react';
import type { JSONContent } from '@tiptap/core';

import { InteractionRichTextField } from './InteractionRichTextField';
import { comparisonSliderToolbarStyles } from './comparisonSliderEditorStyles';

interface ComparisonSliderFieldEditorProps {
  content: JSONContent;
  placeholder: string;
  allowLists?: boolean;
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onContentChange: (content: JSONContent) => void;
  autoFocus: boolean;
  containerRef: RefObject<HTMLDivElement | null>;
  editorStyle?: CSSProperties;
  hideToolbar?: boolean;
  defaultBold?: boolean;
}

export function ComparisonSliderFieldEditor({
  content,
  placeholder,
  allowLists = false,
  isFocused,
  onFocus,
  onBlur,
  onContentChange,
  autoFocus,
  containerRef,
  editorStyle,
  hideToolbar = false,
  defaultBold = false,
}: ComparisonSliderFieldEditorProps) {
  return (
    <InteractionRichTextField
      content={content}
      placeholder={placeholder}
      isFocused={isFocused}
      onFocus={onFocus}
      onBlur={onBlur}
      onContentChange={onContentChange}
      autoFocus={autoFocus}
      containerRef={containerRef}
      editorClassName="tiptap cs-editor"
      editorStyle={editorStyle}
      toolbarPreset="full"
      toolbarStyles={{
        toolbar: comparisonSliderToolbarStyles.toolbar,
        button: comparisonSliderToolbarStyles.toolbarButton,
        activeButton: comparisonSliderToolbarStyles.toolbarButtonActive,
      }}
      shouldRerenderOnTransaction
      hideToolbar={hideToolbar}
      defaultBold={defaultBold}
    />
  );
}
